<template>
  <div>
    <salvar-grupo-contatos-dialog
      :is-dialog-open.sync="isEditarItemDialogOpen"
      :grupo-contatos-data="grupoContatosSelecionado"
      @refetch-data="$emit('refetch-data')"
    />

    <v-data-table
      :headers="headers"
      :items="items"
      :footer-props="{
        'items-per-page-text':'Linhas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
      :item-class="cursorPointer"
      :loading="loading"
      class="elevation-1"
      no-data-text="Nenhum grupo de contatos adicionado"
    >
      <template #[`item.nome`]="{ item }">
        <div class="d-flex align-center">
          <v-avatar
            :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
            size="32"
          >
            <span :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold`">
              {{ item.nome.toUpperCase().charAt(0) }}{{ item.nome.toUpperCase().charAt(1) }}
            </span>
          </v-avatar>

          <div class="ms-3 text-capitalize">
            {{ item.nome }}
          </div>
        </div>
      </template>

      <template #[`item.descricao`]="{ item }">
        <span class="text-capitalize">{{ item.descricao }}</span>
      </template>

      <template #[`item.qtdeContatos`]="{ item }">
        <v-chip
          class="ml-n5"
          color="primary"
        >
          {{ item.qtdeContatos }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-menu
          left
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              class="ml-n5"
              v-bind="attrs"
              v-on="on"
              color="primary"
            >
              <v-icon>
                {{ icons.mdiDotsVertical }}
              </v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item>
              <v-list-item-title
                role="button"
                @click="openEditarItemDialog(item)"
              >
                <v-icon
                  size="20"
                  class="mr-2"
                >
                  {{ icons.mdiFileEdit }}
                </v-icon>

                <span>Editar</span>
              </v-list-item-title>
            </v-list-item>

            <v-list-item @click="agendarEnvioParaGrupo(item)">
              <v-list-item-title
                role="button"
                class="d-flex"
              >
                <v-icon
                  size="20"
                  class="mr-2"
                >
                  {{ icons.mdiClockOutline }}
                </v-icon>

                <span>Agendar envio</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiDotsVertical, mdiFileEdit, mdiClockOutline } from '@mdi/js'
import SalvarGrupoContatosDialog from '@/views/envio-em-massa/grupo-contatos/SalvarGrupoContatosDialog.vue'
import { useRouter } from '@/@core/utils'

export default {
  components: {
    SalvarGrupoContatosDialog,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  setup() {
    const isEditarItemDialogOpen = ref(false)
    const grupoContatosSelecionado = ref(null)

    const { router } = useRouter()

    function openEditarItemDialog(item) {
      isEditarItemDialogOpen.value = true
      grupoContatosSelecionado.value = JSON.parse(JSON.stringify(item))
    }

    function agendarEnvioParaGrupo(item) {
      router.push({ name: 'agendamentos-envio-mensagens', query: { grupoContatoId: item.id } })
    }

    return {
      isEditarItemDialogOpen,
      grupoContatosSelecionado,
      openEditarItemDialog,
      agendarEnvioParaGrupo,
      icons: {
        mdiDotsVertical,
        mdiFileEdit,
        mdiClockOutline,
      },
      cursorPointer: item => (item.ativo ? 'cursor-pointer' : ''),
    }
  },
}
</script>
